import React from 'react'
import { Box, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  activeIcon: {
    color: theme.palette.grey[800],
  },
  nonActiveIcon: {
    color: theme.palette.grey[300],
  },
}))

type Props = {
  icon: React.ReactElement
  isActive: boolean
}

export function IndicatorIcon({ icon, isActive }: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <Box
      p={2}
      className={isActive ? classes.activeIcon : classes.nonActiveIcon}
    >
      {icon}
    </Box>
  )
}
